'use strict';

(function ($) {

  const Drupal = Drupal || {};

  // temp dog-nail for IE11
  // TODO: add babel polyfills
  let _ce = {};
  if ( typeof window.CustomEvent !== "function" )
  {
      _ce.CustomEvent = function ( event, params ) {
         params = params || { bubbles: false, cancelable: false, detail: undefined };
         var evt = document.createEvent('CustomEvent');
         evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
         return evt;
      }

     _ce.CustomEvent.prototype = window.Event.prototype;

     window.CustomEvent = _ce.CustomEvent;
  }
  // temp dog-nail for IE11

  class Breakpoints {
    constructor() {
      this.afterElement = window.getComputedStyle ? window.getComputedStyle(document.body, ':after') : false;
      this.currentBreakpoint = '';
      this.previousBreakpoint = '';

      if(!this.afterElement) {
        return;
      }

      this._initResizeListener();
    }

    _initResizeListener() {
      this.currentBreakpoint = this.previousBreakpoint = this.afterElement.getPropertyValue('content').replace(/"/g, '');

      const event = new CustomEvent('breakpointchange', {
        detail: {
          currentBreakpoint: this.currentBreakpoint,
          previousBreakpoint: this.previousBreakpoint
        }
      });

      setTimeout(() => {
        window.dispatchEvent(event);
      }, 50);

      window.addEventListener('resize', () => {
        this._updateCurrentBreakpoint();
      });

      window.addEventListener('orientationchange', () => {
        this._updateCurrentBreakpoint();
      });

      window.addEventListener('load', () => {
        this._updateCurrentBreakpoint();
      });
    }

    _updateCurrentBreakpoint() {
      let newBP = this.afterElement.getPropertyValue('content').replace(/"/g, '');

      if (this.currentBreakpoint !== newBP) {
        this.previousBreakpoint = this.currentBreakpoint;
        this.currentBreakpoint = newBP;

        const event = new CustomEvent('breakpointchange', {
          detail: {
            currentBreakpoint: this.currentBreakpoint,
            previousBreakpoint: this.previousBreakpoint
          }
        });

        window.dispatchEvent(event);
      }
    }
  }

  window.addEventListener( 'DOMContentLoaded', ()=>{ window.breakpoints = new Breakpoints(); } );

})(jQuery);
